import { SummaryFeatureList } from '../types';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const DefaultTeamsFeatureList: SummaryFeatureList = [
  'collaborate',
  'gather_comments',
  'analyze_results_together',
  'response_alerts',
  'shared_assets',
  'contributor_seats',
  'team_logic',
  'analyze_integrations',
  'response_count',
  'support',
  'quizzes_pro',
  'survey_branding',
  'skip_logic',
  'all_data_exports',
  'payment_qt',
  'statistical_significance',
  'advanced_analyze_features',
  'benchmark_logic',
  'multilingual',
  'sentiment',
];

export default DefaultTeamsFeatureList;
